import React, { useRef, useState } from 'react';

import SelectionSearchView from "views/widgets/SelectionSearchView.jsx";
import WindowDialog from 'views/widgets/WindowDialog.jsx';

export default function SelectionDialog(props) {

	let { label, type, url, columns, sort, initialHeight = 700, initialWidth = 850, 
		  cancelCallback, okCallback, additionalUrlParams, toolTip, checkboxColumnWidth } = props;

	const [ selectedState, setSelectedState ] = useState({});
	const widthMatches = window.matchMedia("(min-width: 850px)").matches;
	const heightMatches = window.matchMedia("(min-height: 700px)").matches;

	const okBtnClicked = () => {
		okCallback(selectionView.current.getSelectedFullObjects());
	};
	
	const getSelectionView = () => {
		return (
			<SelectionSearchView
				ref={selectionView}
				hideLabel={true}
				className="constituo-selection-view"
				gridClass="constituo-selection-grid-container"
				label={label}
				elemId="selectionView"
				columns={columns}
				sort={sort} 
				type={type}
				url={url}
				additionalUrlParams={additionalUrlParams}
				selectionModel={"multiple"}
				selectedState={selectedState}
				setSelectedState={setSelectedState}
				toolTip={toolTip}
				checkboxColumnWidth={checkboxColumnWidth}
			/>			
		);
	}

	const selectionView = useRef();
	
	const render = () => {
		return (
	    	<div className="constituo-dialog-grid-panel constituo-dialog-grid-panel-padded">
	        	{getSelectionView()}
	        </div>			
		);
	};
	
	const getButtons = () => {
		return [
			(<button
				tabIndex={0}
				key="ok-btn"
				className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
				onClick={okBtnClicked}
			>
				OK
			</button>),
			(<button
				tabIndex={0}
				key="cancel-btn"
				className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
				onClick={cancelCallback}
			>
				Cancel
			</button>)
		];
	};
	
	return (
		<WindowDialog
			contentLayout="grid"
			title={"Select " + label}
			onClose={cancelCallback}
			initialHeight={heightMatches ? initialHeight : 400}
			minHeight={350}
			initialWidth={widthMatches ? initialWidth : 400}
			minWidth={400}
			render={render}
			buttons={getButtons()}
		/>
	);
}
